import React, { useContext, useEffect, useState } from 'react';

import './index.scss';
import {
    Modal,
    TaskDetails,
    AddDueDate,
    AccessPermission,
    Reminder,
    MultiSelect
} from 'components';
import { AuthContext, CollaboratorsContext, FtaAdvisorContext, HomeContext, ManagementContext, ModalContext, ShipmentInfoContext, TemplateContext } from 'contexts';
import { useForm } from 'react-hook-form';
import avatar from 'assets/images/avatar.png';
import { accessPermissions, dueDateOptions, dueDates } from 'utils';
import moment from 'moment';
import { ACTION_TYPE, ALL, COLLABORATORS_PAGE_SIZE, GET_FILE, MEMBER, MYTASK, VDL } from 'actions';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const AddTask = ({ open = false, onCancel }) => {
    const [t] = useTranslation();
    const { 
        isTemplate, 
        isEditTask, 
        sectionId, 
        setNotificationMessage, 
        sectionName, 
        eventTask, 
        documentTask, 
        selectTask, 
        setIsEditTask,
        setCurrentTabManagement,
        currentTabManagement,
        setIsTemplate,
        isAddTaskFta,
        setIsAddTaskFta,
        permissionEditTask,
    } = useContext(HomeContext);
    const { doCreateTask, doUpdateShipmentTask, newEstSection, taskManagements, doGetTaskManagements, doCreateTaskFta } = useContext(ManagementContext);
    const { doAddNewTask, doGetTemplatesDetails, templatesDetails, doUpdateTask } = useContext(TemplateContext);
    const { documentFta } = useContext(FtaAdvisorContext);
    const { doGetCollaborators, collaborators } = useContext(CollaboratorsContext);
    const { setAddTask, setDeleteTask } = useContext(ModalContext);
    const { userInfo } = useContext(AuthContext);
    const { handleSubmit, register, errors, reset, formState } = useForm();
    const [dayAjust, setDayAjust] = useState(1);
    const [sectionType, setSectionType] = useState('')
    const [dateType, setDateType] = useState(dueDates[0]);
    const [eventBasedDate, setEventBasedDate] = useState(dueDateOptions[0]);
    const [date, setDate] = useState(moment(new Date()).format('DD MMM YYYY'));
    const [reminders, setReminders] = useState([{
        key: 0,
        daysBeforeDueDate: 0,
        remindNotification: true,
        remindMail: true,
    }]);
    const [selectedMem, setSelectedMem] = useState([]);
    const { shipmentInfo } = useContext(ShipmentInfoContext);
    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const shipmentId = pathnameArr[pathnameArr.length - 1];
     
     /*eslint-disable */
    useEffect(() => {
        setSelectedMem(isEditTask && eventTask?.partners.length > 0 ? eventTask?.partners.map(item => {
            return {
                id: item?.collaboratorId,
                icon: item?.avatar ? GET_FILE + item?.avatar : avatar,
                title: item?.name,
                description: item?.email,
                type: item?.type,
                permissions: item.permissions.map(permission => {
                    return {
                        id: permission,
                        title: t(generatePermission(permission))
                    }
                })
            }
        }) : [
        //     {
        //     id: eventTask.creator.id,
        //     icon: eventTask.creator.avatar,
        //     title: eventTask.creator.name,
        //     type: MEMBER.toUpperCase(),
        //     permission: [
        //         {
        //             id: 'TASK_MANAGER',
        //             title: 'TASK_MANAGER'
        //         }
                
        //     ]
        // }
    ])
    }, [eventTask, isEditTask])
  
    /*eslint-enable */

    const generatePermission = (permission) => {
        switch (permission) {
            case "TASK_MANAGER":
                return accessPermissions[0].value;
            case "TASK_EDITOR":
                return accessPermissions[1].value;
            case "TASK_OPERATOR":
                return accessPermissions[2].value;
            case "TASK_VIEWER":
                return accessPermissions[3].value;
            default:
                return accessPermissions[3].value;
        }
    }

    const handleAddTask = (data) => {
        const { taskName, typeOfTask, dueDate, eventBasedDate, sectionName, reminders, reminderEnable } = data;
        let selectedDueDate= { }
        if(dateType.id === "specific-date") {
            selectedDueDate = {
                specificDate: new Date(dueDate).getTime(),
            }
        } else {
            selectedDueDate = {
                eventBasedDate: {
                    typeOfEvent: eventBasedDate,
                    dateOfEvent: eventBasedDate === VDL ? shipmentInfo?.addresses?.pod?.date : shipmentInfo?.addresses?.pol?.date,
                    adjustDays:  dayAjust
                }
            }
        }

        const remindSchedule = [];
        reminders.forEach(reminder => {
            if(reminder){
                const dueDate = dateType.id === "specific-date" ? selectedDueDate.specificDate : 
                                selectedDueDate.eventBasedDate.dateOfEvent + (selectedDueDate.eventBasedDate.adjustDays * 86400000);
                reminder.timeAsMillisecond = isTemplate ? 0 : dueDate - (reminder.daysBeforeDueDate * 86400000);
                remindSchedule.push(reminder);
            }
        })

        let payload = {
            taskName: taskName.trim(),
            type: typeOfTask.toUpperCase(),
            dueDate : selectedDueDate,
            reminderEnable,
            remindSchedule
        };

        payload.partners = selectedMem.map(mem => {
            let newMem = {}
            newMem.id = mem?.id
            newMem.type = mem?.type
            // newMem.orgLogo = mem?.orgLogo ? mem?.orgLogo : null
            // newMem.role = mem && mem.roles[0]
            newMem.permissions = mem?.permissions.map(e => e.id)
            return newMem
        })

        const payloadTemplate = {
            name: taskName.trim(),
            type: typeOfTask.toUpperCase(),
            dueDate : {
                eventBasedDate: {
                    typeOfEvent: eventBasedDate,
                    dateOfEvent: null,
                    adjustDays:  dayAjust
                }
            },
            reminderEnable,
            remindSchedule,
            partners: [],
        };
        if(isAddTaskFta) {
            const id =  pathnameArr[2];
            const documents = [
                {
                    fileName: documentFta.docName,
                    documentLink: documentFta.docLink
                }
            ];
            payload = {...payload,
                sectionName: sectionName ? sectionName : sectionType.value,
                documents
            };
            delete payload.type;
            
            doCreateTaskFta(id, payload, () => {
                reset();
                setAddTask(false);
                setSelectedMem([]);
                setCurrentTabManagement(ALL);
                setIsAddTaskFta(false);
                setNotificationMessage(
                    t("home.add-task.notification-message-create")
                );
            });
        }else{
            if (isTemplate === true) {
                doAddNewTask(sectionId, payloadTemplate, () => {
                    reset();
                    setIsTemplate(false);
                    setSelectedMem([]);
                    onCancel();
                    doGetTemplatesDetails(templatesDetails && templatesDetails.id);
                    setNotificationMessage(
                        t("home.add-task.notification-message-create")
                    );
                })
            } else {
                doCreateTask(shipmentId, sectionType.key, payload, () => {
                    reset();
                    setAddTask(false);
                    setSelectedMem([]);
                    setCurrentTabManagement(ALL);
                    setReminders([{
                        key: 0,
                        daysBeforeDueDate: 0,
                        remindNotification: true,
                        remindMail: true,
                    }])
                    setNotificationMessage(
                        t("home.add-task.notification-message-create")
                    );
                });
            }
        }
        
    }

    const handleEditTask = (data) => {
        const { taskName, typeOfTask, dueDate, eventBasedDate, reminders, reminderEnable} = data;
        console.log(reminderEnable);
        // let selectedRole = [];
        let selectedDueDate= { }
        if(dateType.id === "specific-date") {
            selectedDueDate = {
                specificDate: new Date(dueDate).getTime(),
            }
        } else {
            selectedDueDate = {
                eventBasedDate: {
                    typeOfEvent: eventBasedDate,
                    dateOfEvent: !isTemplate ? (eventBasedDate === VDL ? shipmentInfo?.addresses?.pod?.date : shipmentInfo?.addresses?.pol?.date) : null,
                    adjustDays:  dayAjust
                }
            }
        }

        const remindSchedule = [];
        reminders.forEach(reminder => {
            if(reminder){
                const dueDate = dateType.id === "specific-date" ? selectedDueDate.specificDate : 
                                selectedDueDate.eventBasedDate.dateOfEvent + (selectedDueDate.eventBasedDate.adjustDays * 86400000);
                                reminder.timeAsMillisecond = isTemplate ? 0 : dueDate - (reminder.daysBeforeDueDate * 86400000);
                remindSchedule.push(reminder);
            }
        })

        const payload = {
            sectionId: sectionType.key,
            taskName: taskName.trim(),
            type: typeOfTask.toUpperCase(),
                dueDate : selectedDueDate
            ,
            reminderEnable,
            remindSchedule
        };

        payload.partners = selectedMem.map(mem => {
            let newMem = {}
            newMem.id = mem?.id
            newMem.type = mem?.type
            newMem.permissions = mem?.permissions.map(e => e.id)
            return newMem
        })
        payload.logAction = ACTION_TYPE.EDIT_TASK;

        const payloadTemplate = {
            sectionId: sectionType.key,
            name: taskName.trim(),
            type: typeOfTask.toUpperCase(),
            dueDate : {
                eventBasedDate: {
                    typeOfEvent: eventBasedDate,
                    dateOfEvent: null,
                    adjustDays:  dayAjust ? dayAjust : 1
                }
            },
            partners: [],
            // roles: selectedRole,
            reminderEnable,
            remindSchedule
        };

        if (isTemplate === true) {
            doUpdateTask(eventTask.id, payloadTemplate, () => {
                setIsTemplate(false);
                setAddTask(false);
                setSelectedMem([]);
                setIsEditTask(false);
                doGetTemplatesDetails(templatesDetails && templatesDetails.id);
                setNotificationMessage(
                    t("home.add-task.notification-message-update")
            );
            })
        } else {
            doUpdateShipmentTask(shipmentId, eventTask.id, payload, () => {
                setAddTask(false);
                setAddTask(false);
                setIsEditTask(false);
                setSelectedMem([]);
                setReminders([{
                    key: 0,
                    daysBeforeDueDate: 0,
                    remindNotification: true,
                    remindMail: true,
                }])
                if (currentTabManagement === ALL) { 
                    doGetTaskManagements(shipmentId, {
                        page: 0,
                        tab: ALL
                    })
                } else {
                    doGetTaskManagements(shipmentId, {
                        page: 0,
                        tab: MYTASK
                    })
                }
                setNotificationMessage(
                    t("home.add-task.notification-message-update")
                );
            })
        }
        
    }

    const hanndleDeleteTask = () => {
        setAddTask(false);
        setDeleteTask(true);
        setSelectedMem([]);
        setReminders([{
            key: 0,
            daysBeforeDueDate: 0,
            remindNotification: true,
            remindMail: true,
        }])
    }
    
    const handleCloseModal = () => {
        reset();
        onCancel();
        setIsEditTask(false);
        setIsAddTaskFta(false);
        setDateType(dueDates[0]);
        setSelectedMem([]);
        setReminders([{
            key: 0,
            daysBeforeDueDate: 0,
            remindNotification: true,
            remindMail: true,
        }])
    }

    const handleSearchMembers = value => {
        const params = {
            query: value.trim(),
            limit: COLLABORATORS_PAGE_SIZE,
            page: 0,
        };
        doGetCollaborators(shipmentId, params, () => {
        });
    };

    const handleChange = item => {
        console.log(item);
        setSelectedMem(item);
    }

    const handleRemove = (item) => {
        setSelectedMem(selectedMem.filter(val => val.id !== item.id))
    }

    
    return (
        <Modal
            open={open}
            className={`tr__add-task no-padding`}
            onCancel={handleCloseModal}
            title={isTemplate ? 'Task Settings' : (isEditTask ? `${t("home.active-shipment.details.tabs.management-tab.edit-task")}` : `${t("home.active-shipment.details.tabs.management-tab.add-task")}`)}
            cancelButton={isEditTask}
            onCancelClick={hanndleDeleteTask}
            cancelButtonLabel={`${t("home.task.delete-task")}`}
            cancelButtonClassNames="outline"
            cancelButtonType="primary"
            btnClasses={isEditTask ? 'justify-content-between' : 'justify-content-end'}
            submitButton={isTemplate || permissionEditTask}
            submitButtonLabel={isTemplate || isEditTask ? `${t("home.task.edit-task")}` : `${t("home.task.save")}`}
            onSubmitClick={isEditTask ? handleSubmit(handleEditTask) : handleSubmit(handleAddTask)}
            isBackDropClickable={false}
            renderForm={children => (
                <form onSubmit={handleSubmit()} className={`${!permissionEditTask && !isTemplate ? 'disabled' : ''}`}>
                    {children}
                </form>
            )}
        >
            <TaskDetails 
                title={t("home.task.message")}
                register={register}
                errors={errors}
                sectionTask={isTemplate ? templatesDetails.sections : taskManagements}
                sectionName={sectionName}
                eventTask={eventTask}
                documentTask={documentTask ? documentTask : ''}
                isEditTask={isEditTask}
                setSectionType={setSectionType}
                sectionType={sectionType}
                newEstSection={newEstSection}
                sectionId={sectionId}
                selectTask={selectTask}
                isAddTaskFta={isAddTaskFta}
             />
            <AddDueDate 
                title={t("home.task.due-date.label")}
                register={register}
                errors={errors}
                setDayAjust={setDayAjust}
                dayAjust={dayAjust ? dayAjust : 1}
                eventTask={eventTask}
                setDateType={setDateType}
                dateType={dateType}
                date={date}
                setDate={setDate}
                isEditTask={isEditTask}
                eventBasedDate={eventBasedDate}
                setEventBasedDate={setEventBasedDate}
                optionBaseDate={shipmentInfo}
                isAddTaskFta={isAddTaskFta}
             />
            <Reminder
                register={register}
                eventTask={eventTask}
                isEditTask={isEditTask}
                reminders={reminders}
                setReminders={setReminders}
            />
            {!isTemplate && (
                <>
                    <MultiSelect
                        className="tr__add--mems mbx2"
                        options={collaborators && collaborators.length > 0 ? collaborators.filter(mem => !selectedMem.some(m => m.id === mem.collaboratorId) && (userInfo._id !== mem.collaboratorId)).map(item => {
                            return {
                                id: item.collaboratorId,
                                icon: item.type === MEMBER.toUpperCase() ? (item.avatar ?  GET_FILE + item.avatar : avatar) : 'icon-users',
                                title: item.name,
                                description: item.email,
                                type: item.type,
                                roles: item.roles,
                                orgId: item.orgId,
                                permissions: [{
                                    id: accessPermissions[accessPermissions.length - 1]?.key,
                                    title: t(accessPermissions[accessPermissions.length -1]?.value)
                                }]
                            }
                        }) : []}
                        name="addMembers"
                        value={selectedMem}
                        multiple={true}
                        isSelectable={true}
                        label={"Add Collabrator"}
                        onRemove={handleRemove}
                        placeholder={collaborators.filter(mem => (userInfo._id !== mem.collaboratorId)).length === 0 ? "No Collabrators Found" : t("team.placeholderInvite")}
                        onChange={handleChange}
                        onInputChange={handleSearchMembers}
                        errorMessage='Please choose at least 1 member'
                        register={register}
                        errors={errors}
                        formState={formState}
                        type="list"
                    />
                    <AccessPermission 
                        title={t("home.task.permission")}
                        register={register}
                        errors={errors}
                        setSelectedMem={setSelectedMem}
                        selectedMem={selectedMem}
                        eventTask={eventTask}
                        isEditTask={isEditTask}
                        onRemove={handleRemove}
                    />
                </>
            )}
            
        </Modal>
    )
};